import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=3cec2e00&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=3cec2e00&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/var/www/app/components/FormInput.vue').default,FormTextarea: require('/var/www/app/components/FormTextarea.vue').default,Btn: require('/var/www/app/components/Btn.vue').default,CategoryFilters: require('/var/www/app/components/CategoryFilters.vue').default,Category: require('/var/www/app/components/Category.vue').default,Page: require('/var/www/app/components/Page.vue').default})
